






























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisStore, { ReservaDeEquipamentoNoHisEnum } from '@/components/Suporte/Store/SuporteHospitaisStore'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuporteIntegracaoHospital extends Vue {
  $refs!: { formSuporteIntegracaoHospital: HTMLFormElement }

  loadingUpdateHospitalConfiguracaoHis: boolean = false

  formSuporteIntegracaoHospitalRules: { [index: string]: unknown} = {
    valid: true,
  }

  reservaDeEquipamentoItems: Array<{ value: string, text: string}> = [
    { value: ReservaDeEquipamentoNoHisEnum.NaoFazReserva, text: 'Não faz reserva' },
    { value: ReservaDeEquipamentoNoHisEnum.FazReservaDeGrupoEquipamento, text: 'Faz reserva de grupo de equipamento' },
    { value: ReservaDeEquipamentoNoHisEnum.FazReservaDeEquipamento, text: 'Faz reserva de equipamento' },
    { value: ReservaDeEquipamentoNoHisEnum.FazReservaDeGrupoEquipamentoEEquipamento, text: 'Faz reserva de grupo de equipamento e equipamento' },
  ]

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }

  get showModalSuporteIntegracaoHospital() { return this.getSuporteHospitaisStore.modal.integracaoHospital }
  set showModalSuporteIntegracaoHospital(value: boolean) { this.getSuporteHospitaisStore.setModal({ name: 'integracaoHospital', value }) }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  async updateHospitalConfiguracaoHis() {
    this.loadingUpdateHospitalConfiguracaoHis = true

    if (!this.$refs.formSuporteIntegracaoHospital.validate()) return

    const response = await this.getSuporteHospitaisStore.updateHospitalConfiguracaoHis()

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar as configurações ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingUpdateHospitalConfiguracaoHis = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Configurações alteradas com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })

    this.showModalSuporteIntegracaoHospital = false
    this.loadingUpdateHospitalConfiguracaoHis = false
  }

  @Watch('showModalSuporteIntegracaoHospital')
  onChangeShowModalSuporteIntegracaoHospital(value: boolean) {
    if (!value) {
      this.getSuporteHospitaisStore.clearHospitalIntegracao()
      this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
    }
  }
}
